export default __webpack_public_path__ + "static/media/Leaders_IMG-Leader-02A.efb76c18.png";